import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import './MessageDialog.scss';

const MessageDialog = (props) => {
  const {
    title,
    message,
    buttons = [
      { title: 'Close', value: 0 },
    ],
    onClose,
    ...other
  } = props;
  const handlers = buttons.map(button => () => onClose(button.value));
  const makeBtnKey = (btn, i) => i;
  const handleClose = () => {
    onClose(0);
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="message-dialog-title"
      {...other}
      onClose={handleClose}
    >
      <DialogTitle id="message-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        {buttons.map((button, i) => (
          <Button onClick={handlers[i]} key={makeBtnKey(button, i)} color="primary">
            {button.title}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};

MessageDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  buttons: PropTypes.arrayOf(PropTypes.shape()),
};

MessageDialog.defaultProps = {
  buttons: undefined,
};

export default MessageDialog;
